import React from 'react';

export function AllocateToEventModal({ show, summary, events, allocateForm, setAllocateForm, onSubmit, onClose }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center px-4 z-50">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">Allocate Funds to Event</h3>
        <p className="text-gray-600 mb-2">Available Balance: <span className="font-bold text-emerald-600">${summary?.available_balance?.toFixed(2) || '0.00'}</span></p>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium mb-2">Event</label>
            <select
              value={allocateForm.event_id}
              onChange={(e) => setAllocateForm({...allocateForm, event_id: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              required
            >
              <option value="">Select an event</option>
              {events.map(event => (
                <option key={event.event_id} value={event.event_id}>{event.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">Amount ($)</label>
            <input
              type="number"
              step="0.01"
              max={summary?.available_balance || 0}
              value={allocateForm.amount}
              onChange={(e) => setAllocateForm({...allocateForm, amount: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 font-medium mb-2">Notes (optional)</label>
            <input
              type="text"
              value={allocateForm.notes}
              onChange={(e) => setAllocateForm({...allocateForm, notes: e.target.value})}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg"
              placeholder="e.g., For venue rental"
            />
          </div>
          <div className="flex space-x-4">
            <button type="button" onClick={onClose} className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50">
              Cancel
            </button>
            <button type="submit" className="flex-1 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700">
              Allocate Funds
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
